import React, { useState, useEffect } from 'react';
declare global {
  interface Window {
    InstallTrigger: any;
  }
}
function Spiral() {
  const [isFirefox] = useState(() => 
    navigator.userAgent.toLowerCase().indexOf('firefox') > -1
  );
  const words = "你好吃饭学习汉语每天我觉得你好吃饭学习汉语每天我觉得";
  const ANIMATION_DURATION = 16000;
  useEffect(() => {
    if (!isFirefox) return;
    let ANGLE = 360;
    const animation = () => {
      ANGLE -= 0.25;
      document.querySelectorAll(".spiral *").forEach((el, i) => {
        const translateX = Math.sin(ANGLE * (Math.PI / 120)) * 75;
        const translateY = Math.cos(ANGLE * (Math.PI / 120)) * 25;
        const scale = Math.cos(ANGLE * (Math.PI / 120)) * 0.5 + 0.7;
        const opacity = Math.cos(ANGLE * (Math.PI / 120)) * 0.4 + 0.6;
        const offset = parseInt((el as HTMLElement).dataset.offset || '0');
        const delay = i * (ANIMATION_DURATION / 16) - offset;
        setTimeout(() => {
          (el as HTMLElement).style.transform = `translateX(${translateX}px) translateY(${translateY}px) scale(${scale})`;
          (el as HTMLElement).style.opacity = String(opacity);
        }, delay);
      });
      requestAnimationFrame(animation);
    };
    animation();
  }, [isFirefox]);
  const createSpiralElements = (offset: number) => {
    return words.split("").map((char, i) => (
      <div
        key={`${char}-${i}-${offset}`}
        className="character"
        data-offset={offset}
        style={{ animationDelay: `-${i * (ANIMATION_DURATION / 16) - offset}ms` }}
      >
        {char}
      </div>
    ));
  };
  return (
    <div className="spiral-container">
      <div id="spiral" className="spiral">
        {createSpiralElements(0)}
      </div>
      <div id="spiral2" className="spiral">
        {createSpiralElements((isFirefox ? 1 : -1) * (ANIMATION_DURATION / 2))}
      </div>
    </div>
  );
}
export default Spiral; 